import useDenormalized from "./useDenormalized.js";
export { useDenormalized };
export function selectMeta(state, fetchKey) {
  return state.meta[fetchKey];
}